'use client';

export type SocialTab = 'discover' | 'following';

type Props = {
  isAnonymous: boolean;
  activeTab: SocialTab;
  onChange: (tab: SocialTab) => void;
  isBrowse?: boolean;
};
const socialTabs = [
  { id: 'discover', label: 'Discover' },
  { id: 'following', label: 'Following' },
];

export const SocialTabs = ({
  isAnonymous,
  activeTab = 'discover' as SocialTab,
  onChange,
}: Props) => {
  return (
    <div className="xl:my-3 mb-2 w-full">
      <nav className="flex gap-5 w-full justify-center">
        {socialTabs.map((tab) =>
          isAnonymous &&
          (tab.id === 'followed' || tab.id === 'wishlist') ? null : (
            <button
              key={tab.id}
              onClick={() => onChange(tab.id as SocialTab)}
              className={`
              flex items-center text-base font-medium font-grotesk transition-all duration-200 hover:cursor-pointer p-2 -mb-px
              ${
                activeTab === tab.id
                  ? 'border-b-2 border-black text-black'
                  : 'text-gray-500 hover:text-gray-900'
              }
          `}
            >
              {tab.label}
            </button>
          )
        )}
      </nav>
    </div>
  );
};
